/* eslint-disable */

export const SERVER_URL = {
  development: "http://localhost:3000/api/",
  production: "https://backend.foorweb.online/api/",
};
